import type { TMimeType } from '../definitions'

import asyncMp3Test from './asyncMp3Test'
import canPlayMimeType from './canPlayMimeType'

/**
 * Az adott formátumú hangfájl lejátszásának tesztelése.
 * @param mt - A hangfájl típusa.
 */
export default async function testMimeType (mt: TMimeType): Promise<boolean> {
  const canPlay = canPlayMimeType(mt)

  if (canPlay) {
    return canPlay
  }

  if (mt === 'audio/mpeg') {
    const canPlayMp3 = await asyncMp3Test()

    return canPlayMp3
  }

  return false
}
